import React, {useState} from 'react'
import MailchimpSubscribe from "react-mailchimp-subscribe"

import SubHeading from '../SubHeading/SubHeading'
import {motion} from 'framer-motion'
import './Newsletter.css';

const Newsletter = () => {

  const mailChimp_URL = process.env.REACT_APP_MAILCHIMP_URL

  const [email, setEmail] = useState(null)
  const  [error, setError] = useState(null)

  return (

    <MailchimpSubscribe
    url={ mailChimp_URL }
    render={ ( { subscribe, status, message } ) => {

      const handleSubmit = () => {

        setError(null);
    
        if ( ! email ) {
          setError( 'Please enter a valid email address' );
          return null;
        }
    
        const isFormValidated = subscribe({ EMAIL: email });
    
        // On success return true
        return email && email.indexOf("@") > -1 && isFormValidated;
      }

      const handleInputKeyEvent = ( event ) => {
        setError(null);
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
          // Cancel the default action, if needed
          event.preventDefault();
          // Trigger the button element with a click
          handleSubmit();
        }
      }

      const getMessage = (message) => {
        if ( !message ) {
          return null;
        }
        const result = message?.split('-') ?? null;
        if ( "0" !== result?.[0]?.trim() ) {
          return result?.[0]?.trim();
        }

        const formattedMessage = result?.[1]?.trim() ?? null;
        return formattedMessage ? formattedMessage : null;
      }

      return (
        // <NewsletterForm
        //   status={ status }
        //   message={ message }
        //   onValidated={ formData => subscribe( formData ) }
        // />
        <div className="app__newsletter">

        <div className="app__newsletter-heading">
          <SubHeading title="Newsletter" divCentrado={1} />
          <h1 className="headtext__cormorant">{"Subscribe To Our Newsletter"}</h1>
          <p className="p__opensans">And never miss latest Updates!</p>
        </div>
        <div className="app__newsletter-input flex__center">
          <form>
            <input  onKeyUp={(event) => handleInputKeyEvent(event)} onChange={(event) => setEmail(event?.target?.value ?? '')} type="email" placeholder="Enter your email address" />
              <motion.button onClick={() => { handleSubmit() }}  whileHover={{scale: 1.1,transition: { duration: 0.5 },}} whileTap={{ scale: 0.9 }} type="button" className="custom__button">Subscribe</motion.button>
          </form>
        </div>

        <div style={{marginTop:'10px' }}>
        {status === "sending" && <span style={{ color: "var(--color-brown-primary)",  fontFamily:'var(--font-alt)' ,paddingLeft:'4px' }}>sending...</span>}
        {status === "error" && <span style={{ color: "red", fontFamily:'var(--font-alt)' ,paddingLeft:'4px' }} dangerouslySetInnerHTML={{__html: error || getMessage( message ) }} />}
        {status === "success" && <span style={{ color: "var(--color-brown-primary)", fontFamily:'var(--font-alt)' ,paddingLeft:'4px' }}>Subscribed!</span>}
        </div>
        
      </div>
      );

    } }
  />


)};

export default Newsletter;